import { Navbar, NavbarBrand, Button } from "reactstrap";
import EALogo from "./EALogo";
import { useAuth } from "../context/AuthContext";

const Unauthorised = () => {
  const { REACT_APP_THEME } = process.env;
  const { logout } = useAuth();

  return (
    <>
      <div role="alert" className="text-center">
        <Navbar
          color={REACT_APP_THEME}
          className="navbar-dark bd-navbar"
          expand="lg"
          fixed="top"
          id="ea_navbar"
        >
          <NavbarBrand tag="div" className="d-flex justify-content-start bg-visnet">
            <EALogo
              theme={REACT_APP_THEME}
              displayName={""}
              color="#fff"
              logoColor="#fff"
              logoBgColor="#fab274"
            />
          </NavbarBrand>
        </Navbar>

        <h1 className="pt-3">Unauthorised</h1>
        <pre className="text-danger" style={{ fontSize: "1rem" }}>
          Unfortunately you do not have access to this page, please contact your administrator.
        </pre>
        <Button color="btn btn-primary btn-sm" onClick={logout}>
          Login
        </Button>
      </div>
    </>
  );
};

export default Unauthorised;
